import { jsPDF } from 'jspdf';

class PdfExport {
	constructor(data) {
		this.data = data;
		// eslint-disable-next-line new-cap
		this.doc = new jsPDF('p', 'mm', 'a4');
	}

	get returnData() {
		return this.data;
	}

	exportCurriculo() {
		const lMargin = 20; // left margin in mm
		const rMargin = 20; // right margin in mm
		const pdfInMM = 210; // width of A4 in mm
		let inicialHeight = 20;
		this.doc.setFont(undefined, 'bold');
		this.doc.text(20, inicialHeight, this.data.dados.nome);
		inicialHeight += 5;

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		this.doc.text(20, inicialHeight, this.data.dados.subtitlename);
		inicialHeight += 5;

		this.doc.setDrawColor(230, 232, 250);
		this.doc.setLineWidth(0.1);
		this.doc.line(20, inicialHeight, 190, inicialHeight);
		inicialHeight += 20;

		this.doc.setFont(undefined, 'bold');
		this.doc.setFontSize(14);
		this.doc.text(20, inicialHeight, 'Dados Pessoais');
		inicialHeight += 10;

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		this.doc.setTextColor('#52b788');
		this.doc.text(20, inicialHeight, this.data.dados.email);
		inicialHeight += 5;

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		this.doc.setTextColor('#000000');
		this.doc.text(20, inicialHeight, this.data.dados.contato);
		inicialHeight += 5;

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		this.doc.text(20, inicialHeight, this.data.dados.endereco);
		inicialHeight += 10;

		if (this.data.dados.possui_deficiencia) {
			this.doc.setFont(undefined, 'normal');
			this.doc.setFontSize(10);
			this.doc.text(20, inicialHeight, `Possuí Deficiência: ${this.data.dados.possui_deficiencia || 'não'}`);
			inicialHeight += 10;
		}

		if (this.data.dados.possui_filho) {
			this.doc.setFont(undefined, 'normal');
			this.doc.setFontSize(10);
			this.doc.text(20, inicialHeight, `Possuí Filhos: ${(this.data.dados.possui_filho === 1 ? 'Sim' : null) || 'não'}`);
			inicialHeight += 10;
		}

		this.doc.setFont(undefined, 'bold');
		this.doc.setFontSize(14);
		this.doc.text(20, inicialHeight, 'Objetivos');
		inicialHeight += 10;

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		const lines = this.doc.splitTextToSize(this.data.dados.objetivo, pdfInMM - lMargin - rMargin);
		this.doc.text(lines, 20, inicialHeight, 'left'); // see this line

		this.doc.setFont(undefined, 'bold');
		this.doc.setFontSize(14);
		inicialHeight += (lines.length * 5 + 10);
		this.doc.text('Resumo Profissional', 20, inicialHeight);

		inicialHeight += 15;
		let resumoTxt = `${this.data.dados.resumo || 'Não Informado'}`;
		resumoTxt = resumoTxt.replace(/\n/g, ', ');

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		resumoTxt = this.doc.splitTextToSize(resumoTxt, pdfInMM - lMargin - rMargin);
		this.doc.text(resumoTxt, 20, inicialHeight, 'left');
		inicialHeight += (resumoTxt.length * 5 + 7);
		if (inicialHeight > 290) {
			this.doc.addPage();
			inicialHeight = 20;
		}

		this.doc.setFontSize(10);
		this.doc.text(`Último Salário: ${this.data.dados.ultimo_salario}`, 20, inicialHeight);
		inicialHeight += 7;
		if (inicialHeight > 290) {
			this.doc.addPage();
			inicialHeight = 20;
		}

		this.doc.text(`Pretensão Salarial: ${this.data.dados.pretensao}`, 20, inicialHeight);
		inicialHeight += 15;
		if (inicialHeight > 290) {
			this.doc.addPage();
			inicialHeight = 20;
		}

		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		this.doc.setTextColor('#000000');

		let baseHeight = 0;
		this.data.exp.forEach((experiencia) => {
			this.doc.text(20, inicialHeight, `Empresa: ${experiencia.empresa}`);
			inicialHeight += 7;

			this.doc.text(20, inicialHeight, `Segmento: ${experiencia.segmento}`);
			inicialHeight += 7;

			this.doc.text(20, inicialHeight, `Cargo: ${experiencia.cargo}`);
			inicialHeight += 7;

			this.doc.text(20, inicialHeight, `Período: ${experiencia.intervalo}`);
			inicialHeight += 7;
			const texto = `Descrição: ${experiencia.descricao || 'Não Informado'}`;
			const descricao = this.doc.splitTextToSize(texto, pdfInMM - lMargin - rMargin);

			const textHeight = inicialHeight + descricao.length * 7 + 10;
			if (textHeight > 290) {
				this.doc.addPage();
				inicialHeight = 20;
				baseHeight = descricao.length * 7 + 10;
			}
			this.doc.text(descricao, 20, inicialHeight, 'left');
			inicialHeight = inicialHeight + descricao.length * 7 + 10;
		});

		if (baseHeight > 0) {
			inicialHeight += 20;
		}
		if (inicialHeight > 290) {
			this.doc.addPage();
			inicialHeight = 20;
		}
		this.doc.setFont(undefined, 'bold');
		this.doc.setFontSize(14);
		this.doc.text('Formação', 20, inicialHeight);
		this.doc.setFont(undefined, 'normal');
		this.doc.setFontSize(10);
		inicialHeight += 10;

		this.data.formacao.forEach((formacao) => {
			if (
				(formacao.formacao && formacao.formacao !== '0')
       || formacao.curso_formacao || formacao.situacao_formacao) {
				this.doc.text(20, inicialHeight, `Nome: ${formacao.formacao}`);
				inicialHeight += 7;
				if (inicialHeight > 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}

				this.doc.text(20, inicialHeight, `Curso: ${formacao.curso_formacao || 'Não Informado'}`);
				inicialHeight += 7;
				if (inicialHeight > 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}

				this.doc.text(20, inicialHeight, `Situacão: ${formacao.situacao_formacao !== '0' ? formacao.situacao_formacao : 'Não Informado'}`);
				inicialHeight += 13;
				if (inicialHeight > 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}
			}
			if ((formacao.especializacao && formacao.especializacao !== '0') || formacao.curso_especializacao) {
				this.doc.text(20, inicialHeight, `Nome: ${formacao.especializacao}`);
				inicialHeight += 7;
				if (inicialHeight > 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}

				this.doc.text(20, inicialHeight, `Curso: ${formacao.curso_especializacao || 'Não Informado'}`);
				inicialHeight += 7;
				if (inicialHeight > 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}

				this.doc.text(20, inicialHeight, `Situacão: ${formacao.situacao_especializacao !== '0' ? formacao.situacao_formacao : 'Não Informado'}`);
				inicialHeight += 13;
				if (inicialHeight >= 290) {
					this.doc.addPage();
					inicialHeight = 20;
				}
			}
		});
		if (this.data.dados.outros_cursos) {
			inicialHeight += 13;
			this.doc.setFont(undefined, 'normal');
			this.doc.setFontSize(10);
			let texto = `Outros Cursos: ${this.data.dados.outros_cursos || 'Não Informado'}`;
			texto = texto.replace(/\n/g, ', ');
			const descricao = this.doc.splitTextToSize(texto, pdfInMM - lMargin - rMargin);
			this.doc.text(descricao, 20, inicialHeight, 'left');
			inicialHeight += descricao.length * 7 + 13;
			if (inicialHeight > 290) {
				this.doc.addPage();
				inicialHeight = 20;
			}
		}

		this.data.area.forEach((areaInteresse) => {
			this.doc.text(20, inicialHeight, `Área de Interesse: ${areaInteresse.area}`);
			inicialHeight += 7;
			if (inicialHeight > 290) {
				this.doc.addPage();
				inicialHeight = 20;
			}
		});

		this.doc.save(
			`${this.data.dados.nome ? `${this.data.dados.nome.trim()}.pdf` : 'sujeitodesconhecido.pdf'}`
		);
	}
}
export default PdfExport;
